import screens from './src/styles/breakpoints.json'

// Tailwind theme config extracted for use in React components.
// tailwind.config.js uses require() which prevents Vite from converting it to ESM.
// This file contains only data (no require), so Vite handles it in both dev and build.
export const theme = {
  screens,
  fontFamily: {
    sans: [
      'Nunito Sans',
      '-apple-system',
      'BlinkMacSystemFont',
      'Segoe UI',
      'Roboto',
      'Helvetica Neue',
      'Aria',
      'Noto Sans',
      'sans-serif',
      'Apple Color Emoji',
      'Segoe UI Emoji',
      'Segoe UI Symbol',
      'Noto Color Emoji'
    ],
    header: [
      'Nunito Sans',
      '-apple-system',
      'BlinkMacSystemFont',
      'Segoe UI',
      'Roboto',
      'Helvetica Neue',
      'Aria',
      'Noto Sans',
      'sans-serif',
      'Apple Color Emoji',
      'Segoe UI Emoji',
      'Segoe UI Symbol',
      'Noto Color Emoji'
    ]
  },
  aspectRatio: {
    square: [1, 1],
    '16/9': [16, 9],
    '4/3': [4, 3],
    '21/9': [21, 9]
  },
  extend: {
    zIndex: {
      5: 5,
      15: 15
    },
    width: {
      1.5: '0.4rem',
      2.5: '.65rem',
      3.5: '.85rem',
      7: '1.75rem',
      26: '6.5rem',
      28: '7rem',
      72: '18rem',
      80: '20rem',
      84: '21rem',
      88: '22rem',
      92: '23rem',
      104: '26rem',
      110: '30rem',
      118: '32rem',
      140: '35rem',
      144: '36rem',
      160: '40rem',
      168: '42rem',
      184: '46rem',
      188: '47rem',
      256: '64rem',
      '1/1': '100%',
      '1/7': '14.28%',
      '1/8': '12.5%',
      '1/9': '11.111%',
      '1/10': '10%',
      'max-content': 'max-content'
    },
    maxWidth: {
      40: '10rem',
      188: '47rem'
    },
    minWidth: {
      5: '5rem',
      104: '26rem',
      768: '768px'
    },
    height: {
      9: '2.25rem',
      26: '6.5rem',
      36: '9rem',
      72: '18rem',
      78: '19.5rem',
      128: '32rem',
      256: '64rem',
      '1/4': '25%',
      '1/2': '50%'
    },
    margin: {
      '.5': '0.075em',
      36: '9rem',
      38: '9.5rem'
    },
    padding: {
      '.1': '0.1em',
      '.02': '0.02em',
      7.5: '1.8rem'
    },
    maxHeight: {
      64: '16rem',
      128: '32rem',
      '75vh': '75vh',
      '50vh': '50vh'
    },
    minHeight: {
      24: '6rem'
    },
    opacity: {
      90: '0.9'
    },
    letterSpacing: {
      sectionTitle: '.5em',
      title: '1rem'
    },
    colors: {
      white: '#ffffff',
      disabledGray: '#444444',
      halfTransparent: 'rgba(255, 255, 255, 0.6)',
      highOpacity: 'rgba(244, 244, 244, 0.97)',
      modalBackdrop: 'rgba(54, 65, 74, 0.88)',
      bigStone: '#12202b',
      cerulean: '#007dcc',
      ceruleanTransparent: 'rgba(0, 125, 204, 0.51)',
      azure: '#009cff',
      grayTransparent: 'rgba(107, 107, 107, 0.32)',
      darkGrayTransparent: 'rgba(50, 50, 50, 0.80)',
      blackTransparent: 'rgba(0, 0, 0, 0.80)',
      darkBlue: '#14304c',
      navyBlue: '#1a5279',
      windowsBlue: '#357fc8',
      lightNavy: '#1b5c85',
      modalGrey: 'rgba(244, 244, 244, 0.95)',
      gray: {
        100: '#f4f4f4',
        150: '#f0f0f0',
        200: '#eeeeee',
        225: '#ebebeb',
        250: '#d2d0d0',
        300: '#c9c9c9',
        350: '#b9b8b8',
        400: '#b4b4b4',
        550: '#989898',
        600: '#888888',
        650: '#777777',
        630: '#717171',
        700: '#6b6b6b',
        730: '#606970',
        750: '#4d5357',
        770: '#444444',
        800: '#404040',
        850: '#373737',
        860: '#2a2727',
        880: '#1d2830',
        900: '#1b1a1a',
        930: '#111f2a',
        950: '#081027'
      },
      vermillion: '#f52424',
      mako: '#44494D',
      scienceBlue: '#0960BA',
      scienceBlueTransparent: 'rgba(9, 96, 186, 0)',
      scienceBlueSemiTransparent: 'rgba(9, 96, 186, 0.267)',
      darkBlueGrey: '#1b3651',
      neutralW50: '#717070'
    },
    borderWidth: {
      3: '3px'
    },
    borderRadius: {
      lg: '2.5rem'
    },
    fontSize: {
      xxs: '0.5rem',
      xs: '0.625rem',
      '15xl': '1.5rem',
      '2xl': '1.6rem',
      '4xl': '2.4rem'
    },
    boxShadow: {
      default: '0 3px 2px 0 rgba(0, 0, 0, 0.16)',
      button: '0 4px 4px 0 rgba(0, 0, 0, 1)',
      buttonLight: '0 4px 4px 0 rgba(150, 150, 150, 1)'
    },
    cursor: {
      colResize: 'col-resize'
    }
  },
  inset: {
    0: 0,
    auto: 'auto',
    '-1': '-1px'
  }
}
